"use strict";

module.exports = {
	/* We're only allowing one spinner per "level". If an element is passed in we can't add a second spinner to that element.
	 * We also only allow one spinner across the full page.
	 */
	showSpinner: function ($specificElement) {
		if ($specificElement) {
			if ($($specificElement).find("#overlayWithSpinner").length) {
				// Don't add a spinner if we've already shown one on this element.
				return;
			}
			$($specificElement).append("<div class='overlay targeted' id='overlayWithSpinner'><div class='spinner'><i class='fa fa-spinner fa-spin'></i></div></div>");
		} else {
			if ($("#overlayWithSpinner:not(.overlay.targeted)").length) {
				// Don't add a spinner if we've already shown a full-page one.
				return;
			}
			$("body").append("<div class='overlay' id='overlayWithSpinner'><div class='spinner'><i class='fa fa-spinner fa-spin'></i></div></div>");
		}
	},

	removeSpinner: function ($specificElement) {
		if ($specificElement) {
			$($specificElement).find("#overlayWithSpinner").remove();
		} else {
			$("#overlayWithSpinner:not(.overlay.targeted)").remove();
		}
	},

	showSearchSpinner: function ($specificElement) {
		if (!$specificElement || $specificElement.find(".searchSpinner").length) {
			// Don't add a spinner if the element doesn't exist or we've already shown one on this element.
			return;
		}

		$specificElement.append("<div class='searchSpinner'><div class='spinner'><i class='fa fa-spinner fa-spin'></i></div></div>");
	},

	removeSearchSpinner: function ($specificElement) {
		if ($specificElement) {
			$specificElement.find(".searchSpinner").remove();
		}
	}
};



// WEBPACK FOOTER //
// ./Javascript/client/Spinner.jsx